import { Route } from "react-router-dom";

// import { RequireAuth } from "../../services/auth";
import Client from "./Client";
import ClientList from "./ClientList";
import InfoClient from "./InfoClient/InfoClient";
import AddClient from "./AddClient";
import EditClient from "./EditClient";

export default (
  <Route path="clients" exact element={<Client />}>
    <Route index element={<ClientList />} />
    <Route path="ClientDetails/:id" element={<InfoClient />}>
      {/* <Route path="edit" element={<EditClient />} /> */}
    </Route>
    <Route path="ClientDetails/:id/edit" element={<EditClient />} />
    <Route path="add/:id" element={<AddClient />} />
  </Route>
);